var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOutlineFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42.3607,
    height: 42.3607,
    fill: "#FF9515"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 21.0326C34 13.8386 28.176 8 21 8C13.824 8 8 13.8386 8 21.0326C8 27.3404 12.472 32.5925 18.4 33.8045V24.9424H15.8V21.0326H18.4V17.7744C18.4 15.2591 20.441 13.213 22.95 13.213H26.2V17.1228H23.6C22.885 17.1228 22.3 17.7093 22.3 18.4261V21.0326H26.2V24.9424H22.3V34C28.865 33.3484 34 27.7965 34 21.0326Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineFacebook);
export default __webpack_public_path__ + "static/media/ic_outline-facebook.0c1e114c4b86591c988535c2792e936a.svg";
export { ForwardRef as ReactComponent };